module.exports = __webpack_public_path__ + "images/preview_grey@2x.png?a7b87b3e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/preview_grey@2x.png
// module id = 684
// module chunks = 7